import type { Language } from 'services/i18n';

const BECOME_A_PARTNER_LINK = 'articles/17125928446099';
const GOOGLE_PROFILE_LINK = 'articles/26324324553747';

type HelpCenterContent = {
  faqTab: string;
  contactReason: string;
  newActivity: string;
  newLocation: string;
};

type HelpCenterLocale = HelpCenterContent & {
  baseUrl: string;
  becomePartner: string;
  googleProfile: string;
};

const buildLocaleHelpCenter = (
  content: HelpCenterContent,
  baseUrl: string,
  overrides: Partial<HelpCenterContent> = {},
): HelpCenterLocale => ({
  ...content,
  ...overrides,
  baseUrl,
  becomePartner: BECOME_A_PARTNER_LINK,
  googleProfile: GOOGLE_PROFILE_LINK,
});

const ENGLISH_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'gym-partners',
  contactReason:
    'Gyms Partnership::Questions and doubts about the Partnership application::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Gyms Contract::Add new activities, modalities or services::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Gyms Contract::Add a new gym to the contract::dc.gyms_contract_-_add_new_location::360047066014',
};

const SPANISH_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'gimnasios',
  contactReason:
    'Asociación de gimnasios::Preguntas y dudas sobre la solicitud de asociación::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contrato de gimnasios::Añadir nuevas actividades, modalidades o servicios::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contrato de gimnasios::Añadir un nuevo gimnasio al contrato::dc.gyms_contract_-_add_new_location::360047066014',
};

const PORTUGUESE_BR_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'parceiros',
  contactReason:
    'Parceria com Academias::Dúvidas sobre a inscrição para a Parceria::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contrato com Academias::Adicionar novas atividades, modalidades ou serviços::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contrato com Academias::Adicionar nova academia ao contrato::dc.gyms_contract_-_add_new_location::360047066014',
};

const PORTUGUESE_PT_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'parceiros',
  contactReason:
    'Parceria com Ginásios::Perguntas e dúvidas sobre a candidatura à Parceria::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contratos com Ginásios::Adicionar novas atividades, modalidades ou serviços::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contratos com Ginásios::Adicionar um novo ginásio ao contrato::dc.gyms_contract_-_add_new_location::360047066014',
};

const GERMAN_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'partnereinrichtungen',
  contactReason:
    'Fitnessstudio-Partnerschaft::Fragen und Bedenken zum Partnerschaftsantrag::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Fitnessstudio-Vertrag::Neue Aktivitäten, Modalitäten oder Dienstleistungen hinzufügen::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Fitnessstudio-Vertrag::Ein neues Fitnessstudio in den Vertrag aufnehmen::dc.gyms_contract_-_add_new_location::360047066014',
};

const ITALIAN_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'partners',
  contactReason:
    'Partnership con palestre/centri::Domande e dubbi sull’applicazione Partnership::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contratto con palestre/centri::Aggiungere nuove attività, modalità o servizi::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contratto con palestre/centri::Aggiungere una nuova palestra al contratto::dc.gyms_contract_-_add_new_location::360047066014',
};

const FRENCH_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'gym-partners',
  contactReason:
    'Partenariats avec les gyms/centres::Questions sur la demande de partenariat::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contrats avec les gyms/centres::Ajouter de nouvelles activités, modalités ou services::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contrats avec les gyms/centres::Ajouter un nouvel emplacement::dc.gyms_contract_-_add_new_location::360047066014',
};

const DUTCH_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'gym-partners',
  contactReason:
    'Partnerschap met sportscholen::Vragen over de aanmelding als partner::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contracten met sportscholen::Nieuwe diensten toevoegen::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contracten met sportscholen::Nieuwe locatie toevoegen::dc.gyms_contract_-_add_new_location::360047066014',
};

const ROMANIAN_HELP_CENTER_CONTENT: HelpCenterContent = {
  faqTab: 'im-a-partner',
  contactReason:
    'Parteneriat cu Săli de Sport::Întrebări și nelămuriri privind aplicarea pentru Parteneriat::dc.gyms_partnership_-_questions_and_doubts_about_the_partnership_application::360047066014',
  newActivity:
    'Contracte cu Săli de Sport::Adăugați activități, modalități sau servicii noi::dc.gyms_contract_-_add_new_services::360047066014',
  newLocation:
    'Contracte cu Săli de Sport::Adăugarea unei noi locații::dc.gyms_contract_-_add_new_location::360047066014',
};

export const HELP_CENTER_URLS: Record<Language, HelpCenterLocale> = {
  en: buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-us',
  ),
  'en-US': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-us',
  ),
  'en-GB': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-gb',
    { faqTab: 'im-a-partner' },
  ),
  'en-IE': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-ie',
    { faqTab: 'im-a-partner' },
  ),
  'en-CA': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-ca',
  ),
  es: buildLocaleHelpCenter(
    SPANISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/es-es',
  ),
  'es-ES': buildLocaleHelpCenter(
    SPANISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/es-es',
  ),
  'es-AR': buildLocaleHelpCenter(
    SPANISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/es-ar',
  ),
  'es-CL': buildLocaleHelpCenter(
    SPANISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/es-cl',
  ),
  'es-MX': buildLocaleHelpCenter(
    SPANISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/es-mx',
  ),
  'pt-BR': buildLocaleHelpCenter(
    PORTUGUESE_BR_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/pt-br',
  ),
  pt: buildLocaleHelpCenter(
    PORTUGUESE_BR_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/pt-br',
  ),
  'pt-PT': buildLocaleHelpCenter(
    PORTUGUESE_PT_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/pt-pt',
  ),
  de: buildLocaleHelpCenter(
    GERMAN_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/de-de',
  ),
  'de-LU': buildLocaleHelpCenter(
    GERMAN_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/de-lu',
  ),
  it: buildLocaleHelpCenter(
    ITALIAN_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/it-it',
  ),
  fr: buildLocaleHelpCenter(
    FRENCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/fr-fr',
  ),
  'fr-FR': buildLocaleHelpCenter(
    FRENCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/fr-fr',
  ),
  'fr-CA': buildLocaleHelpCenter(
    FRENCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/fr-ca',
  ),
  'fr-BE': buildLocaleHelpCenter(
    FRENCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/fr-be',
  ),
  'fr-LU': buildLocaleHelpCenter(
    FRENCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/fr-lu',
  ),
  'nl-NL': buildLocaleHelpCenter(
    DUTCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/nl-nl',
  ),
  'nl-BE': buildLocaleHelpCenter(
    DUTCH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/nl-be',
  ),
  ro: buildLocaleHelpCenter(
    ROMANIAN_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/ro-ro',
  ),
  // No dedicated help center locale for AT/CH yet — full English fallback,
  // per PAREXP-1163.
  'de-AT': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-us',
  ),
  'de-CH': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-us',
  ),
  'fr-CH': buildLocaleHelpCenter(
    ENGLISH_HELP_CENTER_CONTENT,
    'https://helpcenter.gympass.com/en-us',
  ),
};

type buildHelpCenterParams = {
  language: Language;
  path: string;
  [key: string]: string;
};

/**
 * Builds the full help center URL with the specified parameters.
 *
 * @param params - An object containing the parameters to construct the URL.
 * @param params.language - The Language to use for the Help Center URL.
 * @param params.path - The specific path within the Help Center e.g /articles.
 * @param params.query - Optional query parameters to include in the URL.
 *
 * @returns The constructed Help Center URL as a string.
 */
export const buildHelpCenterURL = (params: buildHelpCenterParams) => {
  const { language, path, ...query } = params;
  const { baseUrl } = HELP_CENTER_URLS[language];

  const queryString = new URLSearchParams({
    ...query,
    utm_source: 'self-signup',
  }).toString();

  const url = [baseUrl, path]
    .map(value => value.replaceAll(/(?:^\/)|(?:\/$)/g, ''))
    .join('/');

  return `${url}?${queryString}`;
};

/**
 * The localized "become a partner" Help Center article — the one FAQ
 * destination every "already/not yet a partner" surface links to
 * (`CurrentPartnerInfoPage`, the Hub-of-wellness redirect on
 * `OtherBusinessTypePage`), so it isn't rebuilt at each call site.
 */
export const getBecomePartnerUrl = (language: Language) =>
  buildHelpCenterURL({
    language,
    path: HELP_CENTER_URLS[language].becomePartner,
  });
